import { Box, IconButton, Tooltip, Typography } from "@mui/material";
import { Edit } from "@mui/icons-material";
import { AdminToggle, DataTableColumn, StatusBadge } from "../../../components/ui";
import { TutorialModel } from "../../../models/TutorialModel";

type Options = {
    onToggle: (tutorial: TutorialModel) => void;
    onEdit: (tutorial: TutorialModel) => void;
};

/** Colunas da tabela de tutoriais (Título / Subtítulo / Novo / Status / Ações). */
export function buildTutorialColumns({ onToggle, onEdit }: Options): DataTableColumn<TutorialModel>[] {
    return [
        {
            key: "titulo",
            header: "Título",
            width: "2fr",
            render: (row) => <Typography sx={{ fontSize: "13.5px", fontWeight: 600, color: "text.primary" }}>{row.title}</Typography>,
        },
        {
            key: "subtitulo",
            header: "Subtítulo",
            width: "2fr",
            render: (row) => (
                <Typography sx={{ fontSize: "13px", color: "text.secondary", overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap" }}>
                    {row.subtitle}
                </Typography>
            ),
        },
        {
            key: "novo",
            header: "Novo",
            render: (row) =>
                row.new_icon ? <StatusBadge status="Novo" tone="warning" /> : <Typography sx={{ fontSize: "13px", color: "text.disabled" }}>—</Typography>,
        },
        {
            key: "status",
            header: "Status",
            render: (row) => (
                <AdminToggle checked={row.enabled !== false} onChange={() => onToggle(row)} label={row.enabled !== false ? "Ativo" : "Inativo"} />
            ),
        },
        {
            key: "acoes",
            header: "Ações",
            align: "right",
            render: (row) => (
                <Box sx={{ display: "flex", alignItems: "center", justifyContent: "flex-end", gap: 1 }}>
                    <Tooltip title="Editar" placement="top">
                        <IconButton
                            size="small"
                            onClick={(e) => {
                                e.stopPropagation();
                                onEdit(row);
                            }}
                            aria-label="Editar"
                        >
                            <Edit fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </Box>
            ),
        },
    ];
}
